import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import useModal from '@/shared/hooks/useModal'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import useRetrieveActiveContractIdAndType from '@/containers/SubscriptionFormPageNew/Layouts/useRetrieveActiveContractIdAndType'
import { subscriptionFormActionsV2 } from '../../../SubscriptionForm/SubscriptionFormV2Sagas'
import { selectCurrentContractActive } from '../../../SubscriptionForm/SubscriptionFormSelectors'

const useAbandonContract = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { isOpen, setIsOpen } = useModal()
  const { isAdmin, userId } = useSelector(selectAuthData)
  const { type, id } = useRetrieveActiveContractIdAndType()
  const { status = null, createdById } = useSelector(selectCurrentContractActive) || {}
  const userAuthorized = isAdmin || createdById === userId
  const canShowAbandonButton = userAuthorized && ['Energy', 'Telecom', 'Insurance'].includes(type)

  const isAlreadyRetracted = status === 'R0500' || status === 'R0400'

  const handleSubmit = (reason, callback) => {
    dispatch({
      type: subscriptionFormActionsV2.RETRACT_CONTRACT_V2,
      reason,
      id,
      callback: (_response, status) => {
        const success = status === 200
        callback(success)
        if (success) setIsOpen(false)
      },
    })
  }

  return {
    t,
    isOpen,
    setIsOpen,
    canShowAbandonButton,
    isAlreadyRetracted,
    handleSubmit,
  }
}

export default useAbandonContract
